module.exports = __webpack_public_path__ + "static/media/teamwork1.2b766360.webp";